module.exports = __webpack_public_path__ + "images/enable-unit-details-39e42c5f25390ba6fed7c06669d5507e.jpg";